import { makeStyles } from 'tss-react/mui';

const useDrawerStyles = makeStyles<{ fitHeight: boolean }>()((theme, props) => ({
  mobileHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gridGap: 20,
    padding: '12px',
    position: 'sticky',
    top: 0,
    zIndex: 999,
    backgroundColor: 'white',
  },
  drawerHandler: {
    width: 32,
    height: 4,
    borderRadius: 4,
    backgroundColor: '#D9D9D9',
    margin: '12px 0 4px 0',
  },
  drawer: {
    '&.MuiDrawer-anchorBottom > .MuiDrawer-paper': {
      [theme.breakpoints.only('xs')]: {
        borderRadius: '16px 16px 0 0',
        minHeight: props.fitHeight ? 'fit-content' : '90%',
        maxHeight: props.fitHeight ? 'fit-content' : '90%',
      },
    },
  },
}));

export default useDrawerStyles;
